module.exports = __webpack_public_path__ + "img/restauration-kitchen.6d05b7fe.webp";